var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupList"},[_c('div',{staticClass:"tit"},[_vm._v("拼团活动")]),_c('ul',_vm._l((_vm.groupList),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.toDetail(item.id)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }